import test from './test' // 测试接口

export default {
    test
}
